// /garage — 2-column card grid of the pilot's aircraft.

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Section, Cell, List, Caption, Spinner, Banner, Title, Subheadline,
} from "@telegram-apps/telegram-ui";
import { api } from "../lib/api.js";
import { usePageBack } from "../lib/telegram.js";

const CLASS_LABELS = { F3A: "✈️ Самолёт", F9U: "🚁 Дрон" };

export default function Garage() {
  const navigate = useNavigate();
  usePageBack("/");
  const [aircraft, setAircraft] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api("/api/v1/me/aircraft")
      .then((r) => setAircraft(r.aircraft || []))
      .catch((e) => setError(`Не удалось загрузить гараж: ${e.message}`));
  }, []);

  if (error) {
    return (
      <List>
        <Banner type="section" header="Ошибка">{error}</Banner>
      </List>
    );
  }
  if (aircraft === null) {
    return (
      <List>
        <Section><Cell before={<Spinner size="m" />}>Загружаем модели…</Cell></Section>
      </List>
    );
  }

  return (
    <List>
      <Section header={`Мой гараж · ${aircraft.length}`}>
        {aircraft.length === 0 && (
          <Cell multiline subtitle="Добавьте первую модель — она автоматически станет основной и подставится в мастере бронирования.">
            <span style={{ fontSize: 28 }}>🛩</span> Пока пусто
          </Cell>
        )}
        <div style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 10, padding: 12,
        }}>
          {aircraft.map((a) => (
            <AircraftCard key={a.id} aircraft={a} onClick={() => navigate(`/garage/${a.id}`)} />
          ))}
          <AddCard onClick={() => navigate("/garage/new")} />
        </div>
      </Section>
      <Section>
        <Cell multiline>
          <Caption level="1">
            «Основная» модель подставляется по умолчанию в мастере бронирования. Фото моделей подключим позже.
          </Caption>
        </Cell>
      </Section>
    </List>
  );
}

function AircraftCard({ aircraft, onClick }) {
  const cls = CLASS_LABELS[aircraft.class_code] || aircraft.class_code;
  return (
    <div
      onClick={onClick}
      className={`rcf-aircraft${aircraft.is_primary ? " rcf-aircraft--primary" : ""}`}
    >
      <div className="rcf-aircraft__icon">{silhouetteFor(aircraft.class_code)}</div>
      <div>
        <div className="rcf-aircraft__name">{aircraft.name}</div>
        <div className="rcf-aircraft__class">{cls}</div>
        {aircraft.is_primary && (
          <div className="rcf-aircraft__primary">★ Основная</div>
        )}
      </div>
    </div>
  );
}

function AddCard({ onClick }) {
  return (
    <div onClick={onClick} className="rcf-aircraft rcf-aircraft--add">
      <div className="rcf-aircraft__icon">＋</div>
      <div style={{ fontSize: 13, fontWeight: 500 }}>Добавить модель</div>
    </div>
  );
}

function silhouetteFor(classCode) {
  return classCode === "F9U" ? "🚁" : "✈️";
}
